module.exports = __webpack_public_path__ + "static/media/md.cf5bf1d9.png";